<template>
  <section class="row">
    <div class="col-9 mx-auto">
      <div class="h5">
        Franchise
      </div>
      <div class="text-gray-600 my-3">
        Vous pouvez valider votre modification et passer à la signature des
        déclarations, ou bien poursuivre vos modifications.
      </div>
    </div>
    <div class="col-9 mx-auto">
      <v-minus-plus
        label="null"
        :input-id="`deductible-${contract.id}`"
        :list="deductibles"
        path="deductibles"
        module-name="contract"
        getter-name="get"
        setter-name="updateSubscription"
        :format="({ name }) => name"
        :getter-function="({ deductibles }) => deductibles"
        :setter-function="setDeductible"
      />
    </div>
  </section>
</template>
<script>
import { PlusMinus } from '@/components/common/input';

export default {
  name: 'EditionDeductible',
  components: {
    'v-minus-plus': PlusMinus,
  },
  props: {
    contract: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    deductibles() {
      if (this.contract) {
        return this.contract.deductibles || [];
      }
      return [];
    },
  },
  methods: {
    setDeductible(value, path) {
      return { value, path };
    },
  },
};
</script>
